// extracted by mini-css-extract-plugin
export default {"cards":"kNvqocQZ44G3OcYphZ7v"};